// extracted by mini-css-extract-plugin
module.exports = {"method":"ApiScopes_method__ZDhO1"};